import TextField from "../../../../components/fields/textField/TextField.vue";
import PeriodoField from "../../../../components/fields/periodoField/PeriodoField.vue";
import SelectField from "../../../../components/fields/selectField/SelectField.vue";
import {
  FeriasCivilService
} from "../../../../services/FeriasCivilService";
import moment from "moment";
import {
  SnackBarModule
} from "../../../../modules/SnackBarModule";
import {
  SolicitarFeriasCivilService
} from "../../../../services/SolicitarFeriasCivilService";

import {
  date
} from "date-typescript-library";

import FeriasVantagem from "../ferias-premio/ferias-vantagem/FeriasVantagem.vue";
import { tipoPerfil } from "../../../../constants";


export default {
  name: "FeriasPremios",

  components: {
    TextField,
    PeriodoField,
    SelectField,
    FeriasVantagem
  },

  data: () => ({
    campos: 0,
    form: {},
    feriasVantagemDialog: false,
    role: false,

    responsavelOptions:[],
    responsavel:null,

    exercicios: [],

    loading: {
      field: false,
      btn: false
    }
  }),

  beforeMount() {
    this.role = this.$store.state.user.Perfis.indexOf(tipoPerfil['COMANDANTE']) != -1;
    this.initializeForm();
  },

  mounted() {
    this.getExercicioItems();
    this.getResponsavelItems();
  },

  methods: {

    async getExercicioItems() {
      this.loading.field = true;
      this.exercicios = await FeriasCivilService.getExerciciosFeriasPremio();
      this.loading.field = false;
    },

    async calculateDays(index) {

      if (this.form[index].dataInicio) {

        let result = new Date(this.form[index].dataInicio);
        let ms = result.getTime() + (this.form[index].numeroDias * 24 * 60 * 60 * 1000);

        this.form[index].dataFim = date('Y-m-d', ms);


        //Update no forms inteiro para pode atualizar os valores
        this.form[this.campos] = {}
        this.form.pop()

        return this.calcularTotalDiasRestantes();
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },

    calcularTotalDiasRestantes() {
      const diasRestantesPorExercicio = {};
      let totalDiasRestantes = 90;
    
      for (const value of this.form) {
        const exercicio = value.exercicio;
        const numeroDias = parseInt(value.numeroDias);
    
        if (!diasRestantesPorExercicio[exercicio]) {
          diasRestantesPorExercicio[exercicio] = 25;
        }
    
        diasRestantesPorExercicio[exercicio] -= numeroDias;
        totalDiasRestantes -= numeroDias;
    
        if (diasRestantesPorExercicio[exercicio] < 0) {
          SnackBarModule("Número de dias dos períodos solicitados juntos devem ser menor que 25 por exercício", "error");
          return true;
        }
    
        if (totalDiasRestantes < 0) {
          SnackBarModule("Número de dias dos períodos solicitados juntos devem ser menor que 90 no total", "error");
          return true;
        }
      }
    
      return false;
    },

    async getResponsavelItems() {
      this.loading.field = true;
      const response = await FeriasCivilService.getCivilResponsavel();
      this.responsavelOptions = response.map(el => {
        return {
          text: el.nome,
          value: el.id,
        }
      });
      this.responsavelOptions?.unshift({ text: "Selecione", value: "" })
      this.loading.field = false;
    },

    verificarSeTodasDatasIniciasSaoMenoresQueUltimaDataFinal() {
      if (this.campos > 1) {
        this.form.forEach((value) => {
          if (this.form[this.campos - 1].dataInicio < value.dataFim) {
            return SnackBarModule("A data início deverá ser maior que a data final da última parcela", "error");
          }
        })
      }
      return;
    },

    prepareForm() {
      const formData = new FormData();
      let form = true;
      this.form.forEach((element, index) => {
        form = !this.calcularTotalDiasRestantes();

        if (element.dataInicio == null || element.dataFim == null || element.exercicio == "" || element.numeroDias == "") {
          form = false
          SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");

        }

        if(element.numeroDias != 15 && element.numeroDias != 30){
          form = false;
          SnackBarModule("Dias de férias diferente de 15 ou 30.", "error");

        }

        if(this.role){
          if(!this.responsavel){
            form = false
            SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
          }
        }

        formData.append(`ferias[${index}][data_ini]`, moment(element.dataInicio).format("YYYY-MM-DD"))
        formData.append(`ferias[${index}][data_fin]`, moment(element.dataFim).format("YYYY-MM-DD"))
        formData.append(`ferias[${index}][exercicio]`, element.exercicio)
        formData.append(`ferias[${index}][id_tipo]`, 4)
        formData.append(`ferias[${index}][dias]`, element.numeroDias)


      });

      formData.append(`id_responsavel_ferias`,this.responsavel)



      if (form) {
        this.sendForm(formData);
        return;
      }

    },

    createNewForm() {
      this.campos = this.campos + 1
      this.form[this.campos - 1] = {
        subtitulo: "Por favor selecione uma parcela",
        exercicio: "",
        dataInicio: null,
        dataFim: null,
        numeroDias: ""
      }
    },


    removePeriodoFerias() {
      this.diasLimite = this.diasLimite + parseInt(this.form[this.campos - 1].numeroDias)
      this.form.pop()
      this.campos = this.campos - 1

    },

    async sendForm(formData) {
      this.loading.btn = true;
      const response = await SolicitarFeriasCivilService.postFeriasPremio(formData);
      this.loading.btn = false;
      if (response) {
        this.initializeForm();
        this.$emit('on-confirm');
        this.close();
      }
      this.loading.btn = false;
    },

    initializeForm() {
      this.campos = 1
      this.form = [{
        exercicio: "",
        dataInicio: null,
        dataFim: null,
        numeroDias: ""
      }]
    },

    close() {
      this.$emit("on-close");
    },
  }
};